/**
 * After switching tenant, keep the current section when safe.
 * Entity detail URLs (with numeric id) fall back to the list parent.
 */
const SAFE_EXACT_PATHS = new Set([
  "/dashboard",
  "/agenda",
  "/orders",
  "/clients",
  "/professionals",
  "/units",
  "/users",
  "/services",
  "/service-bundles",
  "/products",
  "/expenses",
  "/financial/dre",
  "/integrations",
  "/help",
  "/support/tickets",
  "/marketing/email-campaigns",
]);

const SAFE_PREFIXES = [
  "/settings/",
  "/dashboard",
  "/agenda",
  "/orders",
  "/clients",
  "/professionals",
  "/units",
  "/users",
  "/services",
  "/products",
  "/expenses",
  "/financial/",
  "/integrations",
  "/help",
  "/support/",
  "/marketing/",
];

const DETAIL_PARENT: Array<{ pattern: RegExp; parent: string }> = [
  { pattern: /^\/orders\/\d+/, parent: "/orders" },
  { pattern: /^\/clients\/[^/]+/, parent: "/clients" },
  { pattern: /^\/professionals\/\d+/, parent: "/professionals" },
];

export const resolvePathAfterTenantSwitch = (
  pathname: string,
  fallback = "/dashboard"
): string => {
  const path = pathname.split("?")[0] || fallback;

  for (const rule of DETAIL_PARENT) {
    if (rule.pattern.test(path)) {
      return rule.parent;
    }
  }

  if (SAFE_EXACT_PATHS.has(path)) {
    return path;
  }

  if (SAFE_PREFIXES.some((prefix) => path === prefix.slice(0, -1) || path.startsWith(prefix))) {
    return path;
  }

  return fallback;
};
